// PRODUCTION — advanced collect-data step row flags (gated by showAllFields query)
import React, { Fragment, useState } from 'react'
import tw from 'twin.macro'
import { ConfigRow } from './stepConfigForms/shared/layout'
import { SoloCheckbox } from './stepConfigForms/shared/SoloCheckbox'

export type AdvancedStepRowField =
  | 'ignoreMonitoring'
  | 'recollectSameTypeSteps'
  | 'skipRetroactiveCollectIfAnySameTypeCompleted'

interface Props {
  ignoreMonitoring: boolean
  recollectSameTypeSteps: boolean
  skipRetroactiveCollectIfAnySameTypeCompleted: boolean
  onFieldChange: (field: AdvancedStepRowField, value: boolean) => void
  fieldsEnabled: boolean
  readOnly: boolean
}

export function AdvancedStepRowFields({
  ignoreMonitoring,
  recollectSameTypeSteps,
  skipRetroactiveCollectIfAnySameTypeCompleted,
  onFieldChange,
  fieldsEnabled,
  readOnly,
}: Props) {
  const [expanded, setExpanded] = useState(false)
  const controlsDisabled = readOnly || !fieldsEnabled

  return (
    <div>
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => {
          setExpanded((previous) => {
            return !previous
          })
        }}
        css={tw`flex w-full cursor-pointer appearance-none items-center justify-between border-none bg-transparent px-5 py-3.5 text-left transition-colors duration-150 hover:bg-shades-50`}
      >
        <span css={tw`text-sm font-semibold text-shades-800`}>Advanced configuration</span>
        <span
          css={tw`flex h-7 w-7 flex-shrink-0 items-center justify-center text-shades-600`}
          aria-hidden
        >
          {expanded ? (
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          ) : (
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          )}
        </span>
      </button>

      {expanded ? <div aria-hidden css={tw`h-px bg-shades-300`} /> : null}

      {expanded ? (
        <Fragment>
          <ConfigRow label="Ignore monitoring" disabled={controlsDisabled}>
            <SoloCheckbox
              checked={ignoreMonitoring}
              onChange={(value) => {
                onFieldChange('ignoreMonitoring', value)
              }}
              disabled={controlsDisabled}
            />
          </ConfigRow>
          <ConfigRow label="Recollect same type steps" disabled={controlsDisabled}>
            <SoloCheckbox
              checked={recollectSameTypeSteps}
              onChange={(value) => {
                onFieldChange('recollectSameTypeSteps', value)
              }}
              disabled={controlsDisabled}
            />
          </ConfigRow>
          <ConfigRow label="Skip retroactive if same type done" disabled={controlsDisabled}>
            <SoloCheckbox
              checked={skipRetroactiveCollectIfAnySameTypeCompleted}
              onChange={(value) => {
                onFieldChange('skipRetroactiveCollectIfAnySameTypeCompleted', value)
              }}
              disabled={controlsDisabled}
            />
          </ConfigRow>
        </Fragment>
      ) : null}
    </div>
  )
}
